import * as yup from 'yup'
import { messages } from 'helpers/validationMessages'
import {
  kppSchema,
  ogrnSchema,
} from 'feature/company/validation/companyValidation'

import { User } from '../../types'

export const companyEditFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value?.trim() !== ''),
  lastName: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value?.trim() !== ''),
  fatherName: yup
    .string()
    .nullable()
    .max(100, messages.maxLength(100))
    .test(
      'notOnlySpaces',
      messages.required,
      value => !value || value.trim() !== '',
    ),
  companyName: yup
    .string()
    .required('Название компании обязательно для заполнения')
    .max(128, messages.maxLength(128))
    .test(
      'notOnlySpaces',
      'Название компании обязательно для заполнения',
      value => value?.trim() !== '',
    ),
  kpp: kppSchema,
  ogrn: ogrnSchema,
  directorFullName: yup
    .string()
    .required('ФИО руководителя обязательно для заполнения')
    .max(100, messages.maxLength(100))
    .test(
      'notOnlySpaces',
      'ФИО руководителя обязательно для заполнения',
      value => value?.trim() !== '',
    ),
  directorPosition: yup
    .string()
    .required('Должность руководителя обязательна для заполнения')
    .max(128, messages.maxLength(128))
    .test(
      'notOnlySpaces',
      'Должность руководителя обязательна для заполнения',
      value => value?.trim() !== '',
    ),
})

export const companyEditFormDefaultValues = (data: User | undefined) => ({
  firstName: data?.firstName || '',
  lastName: data?.lastName || '',
  fatherName: data?.fatherName || '',
  companyName: data?.companyName || '',
  kpp: data?.kpp || '',
  ogrn: data?.ogrn || '',
  directorFullName: data?.directorFullName || '',
  directorPosition: data?.directorPosition || '',
})
